import { memo } from 'react';

import OrderPercentSlider from './OrderPercentSlider';
import OrderSizeField from './OrderSizeField';
import OrderTypeHeader from './OrderTypeHeader';

/**
 * 주문 크기 입력 영역의 얇은 컨테이너.
 * 자체 구독이 없고 props도 받지 않으므로 memo로 감싸 부모(PerpetualOrderForm) 리렌더가
 * 이 경계에서 끊기게 한다. 이후 각 하위 컴포넌트가 필요한 atom만 좁게 구독해 독립적으로 리렌더된다:
 * - OrderTypeHeader    : 드롭다운(kind) + 가용 잔고 (값 입력에 무반응)
 * - OrderSizeField     : 수량/금액/마진 입력 + 인라인 에러 (활성 영역, keystroke마다 리렌더)
 * - OrderPercentSlider : 비율 슬라이더 (orderPercent 변경 시에만 리렌더)
 */
const OrderTypeForm = memo(() => {
  return (
    <>
      <OrderTypeHeader />
      <OrderSizeField />
      <OrderPercentSlider />
    </>
  );
});

OrderTypeForm.displayName = 'OrderTypeForm';

export default OrderTypeForm;
